module.exports = require("./../../_gen/starling/text/BitmapFont");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/BitmapFont.js
// module id = 225
// module chunks = 0